export const ACTIONS_KPI_SET = {
  INVALIDATE: 'KPI_SETS_INVALIDATE',
  RECEIVE: 'KPI_SETS_RECEIVE',
  DELETE: 'KPI_SET_DELETE',
  UPDATE: 'KPI_SET_UPDATE',
};

const kpiSetConstants = {};

export default kpiSetConstants;
